import moment from "moment";

export const toString = function(d) {
    return new moment.utc(d).format("YYYY-MM-DD");
};

export const previousDate = function(d, num) {
    return moment
        .utc(d)
        .subtract(num, "day")
        .toDate();
};

export const allCategories = {
    "All Categories": {
        "All Categories": "All Categories",
    },
    "Major Categories": {
        "Food/Meals": "Food/Meals",
        Housing: "Housing",
        "COVID-19 Hotline": "COVID-19 Hotline",
        "Individual, Family and Community Support":
            "Individual, Family and Community Support",
        "Utility Assistance": "Utility Assistance",
        "Disaster Services": "Disaster Services",
        "Information Services": "Information Services",
        "COVID-19 Diagnostic Tests": "COVID-19 Diagnostic Tests",
    },
    "Minor Categories": {
        "Health Care": "Health Care",
        "Other Government/Economic Services":
            "Other Government/Economic Services",
        Employment: "Employment",
        "Legal, Consumer, and Public Safety Services":
            "Legal, Consumer, and Public Safety Services",
        "Income Support/Assistance": "Income Support/Assistance",
        "Clothing/Personal/Household Needs":
            "Clothing/Personal/Household Needs",
        "Mental Health/Addictions": "Mental Health/Addictions",
        Transportation: "Transportation",
        "Volunteers/Donations": "Volunteers/Donations",
        Education: "Education",
    },
};

export const allCities = {
    "All Areas": "All Areas",
    Barrington: "Barrington",
    Bristol: "Bristol",
    Burrillville: "Burrillville",
    "Central Falls": "Central Falls",
    Charlestown: "Charlestown",
    Coventry: "Coventry",
    Cranston: "Cranston",
    Cumberland: "Cumberland",
    "East Greenwich": "East Greenwich",
    "East Providence": "East Providence",
    Exeter: "Exeter",
    Foster: "Foster",
    Glocester: "Glocester",
    Hopkinton: "Hopkinton",
    Jamestown: "Jamestown",
    Johnston: "Johnston",
    Lincoln: "Lincoln",
    "Little Compton": "Little Compton",
    Middletown: "Middletown",
    Narragansett: "Narragansett",
    Newport: "Newport",
    "New Shoreham": "New Shoreham",
    "North Kingstown": "North Kingstown",
    "North Providence": "North Providence",
    "North Smithfield": "North Smithfield",
    Pawtucket: "Pawtucket",
    Portsmouth: "Portsmouth",
    Providence: "Providence",
    Richmond: "Richmond",
    Scituate: "Scituate",
    Smithfield: "Smithfield",
    "South Kingstown": "South Kingstown",
    Tiverton: "Tiverton",
    Warren: "Warren",
    Warwick: "Warwick",
    Westerly: "Westerly",
    "West Greenwich": "West Greenwich",
    "West Warwick": "West Warwick",
    Woonsocket: "Woonsocket",
};

export const categoryDescription = {
    "Food/Meals": "Calls about access to food and meals",
    Housing: "Calls about access to and assistance with housing",
    "COVID-19 Hotline":
        "Calls received via the Rhode Island Department of Health COVID-19 hotline",
    "Individual, Family and Community Support":
        "Calls requesting information and referrals for individual, family, and community support",
    "Utility Assistance":
        "Calls requesting assistance with utility bills, late payment notices, and terminations",
    "Disaster Services":
        "Calls about access to disaster support services such as disaster kits, disaster food stamps and disaster specific rental assistance",
    "Information Services":
        "Calls requesting COVID-19 information and referrals for states other than RI",
    "COVID-19 Diagnostic Tests":
        "Calls requesting information and advice about accessing COVID-19 Diagnostic Test (including locations and appointments)",
    "Health Care": "Calls about access to health care and health insurance",
    "Other Government/Economic Services":
        "Calls requesting information on municipal and state government agencies",
    Employment:
        "Calls about TDI,TCI and unemployment insurance benefits. Calls about job search placements",
    "Legal, Consumer, and Public Safety Services":
        "Calls about legal services, consumer affairs and public safety offices (fire stations, correctional facilities, etc.)",
    "Income Support/Assistance": "Call requesting financial assistance",
    "Clothing/Personal/Household Needs":
        "Calls related to clothing, furniture and household cleaning supplies",
    "Mental Health/Addictions":
        "Calls requesting information about mental health counseling, support groups, substance abuse treatment facilities and crisis hotlines",
    Transportation: "Calls requesting transport (Lyft, Uber, MTM, RIPTA, ADA)",
    "Volunteers/Donations":
        "Calls about volunteering opportunities and those offering and requesting donations of goods and services",
    Education:
        "Calls seeking information related to primary, secondary and adult education",
};
